'use client';
import { useMediaQuery } from '../useMediaQuery/useMediaQuery.js';

const usePreferredMode = (initialValue, options)=>useMediaQuery('(prefers-color-scheme: dark)', {
        fallback: [
            (options == null ? void 0 : options.fallback) || initialValue === 'night'
        ],
        ssr: options == null ? void 0 : options.ssr
    })[0] ? 'night' : 'day';

export { usePreferredMode };
//# sourceMappingURL=usePreferredMode.js.map
